import React from 'react';
import './component-style/Header.css'

const Header = () => {

    return (
        <div className= "header-div">
           <h3 className="title" style={{textDecoration: 'none', color: '#1be67f'}} >MoviesADDICT</h3>
        </div>
    );
}

export default Header;